import { withErrorBoundary } from '../dependencies';

import Lists from '../components/Lists';

export default withErrorBoundary(Lists);
